export default "__VITE_ASSET__ByCrEjeK__"